import { render } from "./AdminSideNav.vue?vue&type=template&id=59b3891b"
import script from "./AdminSideNav.vue?vue&type=script&lang=js"
export * from "./AdminSideNav.vue?vue&type=script&lang=js"

import "./AdminSideNav.vue?vue&type=style&index=0&id=59b3891b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__